// Animate hero illustration
if ('IntersectionObserver' in window) { // Detect support for IntersectionObserver
  const animateHero = '.js-animate-hero' // Define observed targets
  const targets = document.querySelectorAll(animateHero)
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) { // Deal with every intersection
        document.querySelector('.o-hero .illustration').classList.add('animate')
      } else {
        document.querySelector('.o-hero .illustration').classList.remove('animate')
      }
    })
  })
  // Observe targets
  targets.forEach(target => {
    observer.observe(target)
  })
}
